// extracted by mini-css-extract-plugin
export default {"textInputLabel":"pS-z","textInput":"qS-z","error":"rS-z","disabled":"sS-z"};